var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-row"},[_c('BaseDraggable',{ref:"baseDraggable",attrs:{"isRow":true,"type":"Row","config":_vm.config,"data":_vm.info,"curId":_vm.curId},on:{"itemClick":function (v) { return _vm.$emit('itemClick', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }